<template>
  <v-layout>
    <v-dialog class="dialog" v-model="isOpen" width="55%" persistent>
      <v-card id="dialog-card">
        <v-stepper v-model="stepper">
          <!-- <v-stepper-header>
            <v-stepper-step :complete="stepper > 1" step="1">
            </v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="stepper > 2" step="2">
            </v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="stepper > 3" step="3">
            </v-stepper-step>
          </v-stepper-header> -->

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-card-title class="dialog-title">
                  {{ $t('homePage.infoDialog.welcome') }}
                </v-card-title>
                <v-card-title class="dialog-sub-title justify-center">
                  <!-- Voici une vidéo explicative du fonctionnement du studio -->
                  {{ $t('homePage.infoDialog.explanationVideo') }}
                </v-card-title>

                <div id="ytb-player-container">
                  <div id="iframe-video-loading" v-if="!isiFrameLoaded">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span class="primary--text">{{
                      $t('homePage.infoDialog.videoLoading')
                    }}</span>
                  </div>
                  <iframe
                    @load="iFrameLoaded"
                    id="ytb-player"
                    width="533"
                    height="300"
                    src="https://www.youtube.com/embed/qaB0rX7NkTc"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card-title class="dialog-title">
                    <!-- Centre d'aide Explorama -->
                    {{ $t('homePage.infoDialog.helpscout') }}
                  </v-card-title>
                  <v-card-text
                    v-html="$t('homePage.infoDialog.helpScoutExplanation')"
                    style="font-size: 1.2em; text-align: center"
                  >
                  </v-card-text>
                </v-flex>
                <v-flex xs6>
                  <v-card-text
                    v-html="$t('homePage.infoDialog.helpScoutArrow')"
                    style="font-size: 1.2em; text-align: center"
                  >
                  </v-card-text>
                  <v-img
                    src="images/arrow.gif"
                    max-width="100"
                    height="150"
                    style="margin-left: 40%"
                  ></v-img>
                </v-flex>
                <v-flex xs6>
                  <v-card-text
                    v-html="$t('homePage.infoDialog.helpScoutBtn')"
                    style="font-size: 1.2em; text-align: center"
                  >
                  </v-card-text>
                  <v-btn
                    style="margin: 50px auto; display: inherit"
                    color="primary"
                    @click="openBeacon"
                  >
                    {{ $t('homePage.infoDialog.openBeacon') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card-title class="dialog-title">
                {{ $t('homePage.infoDialog.checklistTitle') }}
              </v-card-title>

              <v-card-text
                class="check-list-explanations"
                v-html="$t('homePage.infoDialog.checklistSubtitle')"
                style="font-size: 1.2em; text-align: center"
              >
              </v-card-text>
              <v-card-text
                v-html="$t('homePage.infoDialog.checklistExplanation')"
              >
              </v-card-text>

              <div id="check-list-dialog-container">
                <check-list id="check-list" :previewMode="true"> </check-list>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-flex layout row pl-2 pr-2 style="background-color: white">
          <div id="step-mover">
            <v-btn v-if="stepper > 1" @click="stepRemove">
              {{ $t('homePage.infoDialog.previous') }}
            </v-btn>

            <!--<v-stepper-header>
            <v-stepper-step :complete="stepper >0" step="1">
            </v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="stepper > 1" step="2">
            </v-stepper-step>
            <v-divider/>
            <v-stepper-step :complete="stepper > 2" step="3">
            </v-stepper-step>
          </v-stepper-header> -->

            <v-btn
              v-if="stepper < 3"
              style="float: right"
              @click="stepAdd"
              color="primary"
            >
              {{ $t('homePage.infoDialog.next') }}
            </v-btn>

            <v-btn
              v-else
              style="float: right"
              @click="closeDialog"
              color="primary"
            >
              {{ $t('homePage.infoDialog.close') }}
            </v-btn>
          </div>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import YoutubeVue from 'youtube-vue';
import { VueperSlides, VueperSlide } from 'vueperslides';
import DropDownPanel from '../components/DropDownPanel.vue';
import CheckList from '../components/CheckList.vue';
import 'vueperslides/dist/vueperslides.css';
import { link } from 'fs';

export default {
  name: 'homeInfosDialog',
  components: {
    YoutubeVue,
    VueperSlides,
    VueperSlide,
    DropDownPanel,
    CheckList,
  },
  props: {},
  data() {
    return {
      isOpen: true,
      stepper: 1,
      isiFrameLoaded: false,
      slides: [
        {
          title: 'Parcours, missions, jeux, ... Quésako ?',
          // image: require('../../public/images/trames/article_quésako.png'),
          link: 'https://support.explorama.app/article/19-parcours-missions-jeux-quesako',
        },
        {
          title: 'Quelles informations renseigner dans mon parcours Explorama?',
          // image: require('../../public/images/trames/article_test.png'),
          link: 'https://support.explorama.app/article/6-quelles-informations-renseigner-dans-mon-parcours-explorama',
        },
        {
          title: 'Quelles  .... ?',
          // image: require('../../public/images/trames/article_test2.png'),
          link: 'https://support.explorama.app/article/6-quelles-informations-renseigner-dans-mon-parcours-explorama',
        },
        {
          title: 'Article 4',
          content: 'Article 4 content',
        },
        {
          title: 'Article 5',
          content: 'Article 5 content',
        },
        {
          title: 'Article 6',
          content: 'Article 6 content',
        },
      ],
    };
  },
  computed: {},
  methods: {
    stepAdd() {
      this.stepper += 1;
    },
    stepRemove() {
      this.stepper -= 1;
    },
    openBeacon() {
      window.Beacon('open');
    },
    iFrameLoaded(e) {
      console.log('video loaded in ', e.timeStamp / 1000, ' seconds');
      this.isiFrameLoaded = true;
    },
    closeDialog() {
      localStorage.setItem('hasSeenInfoDialog', true);
      this.isOpen = false;
    },
  },
  watch: {},
};
</script>

<style lang="sass">

.v-card__title
  padding: 10px !important

.v-dialog
  max-height: 95% !important

.dialog-title
  color: #009999;
  font-size: 1.6em;
  justify-content: center;

.dialog-sub-title
  font-size: 1.3em;
  margin-bottom: 15px;

.img-row::after
  content: "";
  clear: both;
  display: table,

strong
  color: #009999;

.img-col
  float: left;
  width: 33.3%;
  padding: 5px;

.img-item
  border: 2px solid #009999;

.panel-container
  padding: 12px;

.v-divider
  margin: 15px;

#step-mover
  width: 100%;

#dialog-card
  max-height: 95vh;

#ytb-player-container
  max-width: 718px;
  max-height: 403px;
  margin: auto;

#iframe-video-loading
  width: 100px;
  height: 100px;
  margin: 20% auto auto auto;
  text-align: center;

#iframe-video-loading > span
  display: block;

#ytb-player
  margin: 0 auto;
  display: inherit;

#check-list-dialog-container
  width: 60%;
  margin: 0 auto;

.check-list-explanations
  padding: 20px !important;
</style>
